import React, { forwardRef } from 'react';
import { cx } from '../utils';
import './ListCard.css';

// Ro'yxat-karta: har qator — sarlavha, izoh (ixtiyoriy) va o'ngdagi qiymat/belgi.
// items: [{ key?, title, subtitle?, meta? }]; bo'sh bo'lsa emptyText ko'rsatiladi.
const ListCard = forwardRef(function ListCard(
  { items = [], emptyText = "Ma'lumot yo'q", className, ...rest },
  ref
) {
  if (!items.length) {
    return (
      <p {...rest} ref={ref} className={cx('ui-list__empty', className)}>
        {emptyText}
      </p>
    );
  }
  return (
    <ul {...rest} ref={ref} className={cx('ui-list', className)}>
      {items.map((item, index) => (
        <li key={item.key ?? `${item.title}-${index}`} className="ui-list__item">
          <div className="ui-list__text">
            <span className="ui-list__title">{item.title}</span>
            {item.subtitle && <span className="ui-list__subtitle">{item.subtitle}</span>}
          </div>
          {item.meta !== undefined && item.meta !== null && <div className="ui-list__meta">{item.meta}</div>}
        </li>
      ))}
    </ul>
  );
});

export default ListCard;
